<mat-card appearance="outlined" class="cur-card">
  <mat-card-header>
    <mat-card-title>検索結果</mat-card-title>
    <mat-icon>view_list</mat-icon>
  </mat-card-header>
  <mat-card-content>

    <mat-form-field>
      <mat-label>Filter</mat-label>
      <input matInput id="fdFilter" (keyup)="applyFilter($event)" #input>
    </mat-form-field>

      <table mat-table [dataSource]="dataSource" style="width: 100%;">
        <ng-container matColumnDef="fileName">
          <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>ファイル名</th>
          <td mat-cell class="border-bottom-dotted" *matCellDef="let row">{{ row.fileName }}</td>
        </ng-container>
        <ng-container matColumnDef="fileSize">
          <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>ファイルサイズ</th>
          <td mat-cell class="border-bottom-dotted" *matCellDef="let row">{{ row.fileSize }}</td>
        </ng-container>
        <ng-container matColumnDef="lastUpdateDate">
          <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>最終更新日付</th>
          <td mat-cell class="border-bottom-dotted" *matCellDef="let row">{{ row.lastUpdateDate }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row class="clickable-mat-row" *matRowDef="let row; columns: displayedColumns;"
            (click)="onClickRow(row)"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
        </tr>
      </table>
    <mat-paginator id="fdPagenator" [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
  </mat-card-content>
</mat-card>
